import { put, takeLatest, all } from "redux-saga/effects";
import axios from "axios";
import { GET_SERVICE_REQUEST, SERVICE_REQUEST_DETAILS, DOWNLOAD_SERVICE_REQUEST } from "../Constants";
import { logout } from "../../utils";
import { GetServiceRequestSuccess, GetServiceRequestFailure, ServiceRequestDetailsSuccess, ServiceRequestDetailsFailure, DownloadServiceRequestFailure, DownloadServiceRequestSuccess } from "../Actions/ServiceRequestAction";
//import {act} from "@testing-library/react";

function* GetServiceRequestRequest(actions) {
  try {
    const headers = { bankid: sessionStorage.getItem("selectedBank"), Authorization: `Bearer ${sessionStorage.getItem("token")}` };
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/service_requests`, {
      headers: headers,
      params: {
        page: actions.payload.page === "" ? "" : actions.payload.page,
        sort_by: actions.payload.sort_by === "" ? "" : actions.payload.sort_by,
        sort_type: actions.payload.sort_type === "" ? "" : actions.payload.sort_type,
        search_key: actions.payload.search_key === "" ? "" : actions.payload.search_key,
      },
    });
    if (res.status === 200) {
      yield put(GetServiceRequestSuccess(res.data));
    } else {
      yield put(GetServiceRequestFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(GetServiceRequestFailure(e));
  }
}

function* GetServiceRequestDetailsRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/service_request_details`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      params: {
        id: actions.payload.id === "" ? "" : actions.payload.id,
      },
    });
    if (res.status === 200) {
      yield put(ServiceRequestDetailsSuccess(res.data));
    } else {
      yield put(ServiceRequestDetailsFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ServiceRequestDetailsFailure(e));
  }
}

function* DownloadServiceRequest(actions) {
  try {
    const res = yield axios.get(`${process.env.REACT_APP_API_URL}api/admin/download_service_requests?date=${actions.payload.date}&user_type=${actions.payload.userType}`, {
      headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
    });
    if (res.status === 200) {
      yield put(DownloadServiceRequestSuccess(res.data));
    } else {
      yield put(DownloadServiceRequestFailure(res));
    }
  } catch (e) {
    if (e.response.status === 401) logout();
    yield put(ServiceRequestDetailsFailure(e));
  }
}

function* actionWatcher() {
  yield takeLatest(GET_SERVICE_REQUEST, GetServiceRequestRequest);
  yield takeLatest(SERVICE_REQUEST_DETAILS, GetServiceRequestDetailsRequest);
  yield takeLatest(DOWNLOAD_SERVICE_REQUEST, DownloadServiceRequest);
}

export default function* AdminSaga() {
  yield all([actionWatcher()]);
}
